const styles = {
  root: {
    height: '100vh',
    boxSizing: 'border-box',
  },
};

export default styles;
